import React from "react";

const TryAgainIcon = (props) => {
	return (
		<svg
			width="25"
			height="25"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				d="M12.5 3.5C10.72 3.5 8.97991 4.02784 7.49987 5.01677C6.01983 6.00571 4.86627 7.41131 4.18508 9.05585C3.5039 10.7004 3.32567 12.51 3.67293 14.2558C4.0202 16.0016 4.87737 17.6053 6.13604 18.864C7.39471 20.1226 8.99836 20.9798 10.7442 21.3271C12.49 21.6743 14.2996 21.4961 15.9441 20.8149C17.5887 20.1337 18.9943 18.9802 19.9832 17.5001C20.9722 16.0201 21.5 14.28 21.5 12.5"
				stroke="#EFF0F6"
				strokeWidth="1.8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default TryAgainIcon;
